// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3sAcp","title":"styles_title__ZnbIB","actions":"styles_actions__-9W75"};